import styled, { css } from 'styled-components';
import { FiX, FiSearch } from 'react-icons/fi';

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled.input`
  color: ${({ theme }) => theme.colors.white};
  background: transparent;
  width: 0%;
  height: 100%;
  border: none;
  padding: 0;
  font-size: 1rem;
  &:focus {
    outline: none;
  }
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled.button`
  color: ${({ theme }) => theme.colors.white};
  background: transparent;
  font-size: 1.125rem;
  border: none;
  outline: 0;
  cursor: pointer;
  padding: 1.125rem 1rem;
  position: absolute;
  right: 0.2rem;
`;

// TODO: TFR-44 move to icons group
export const SearchIcon = styled(FiSearch)`
  visibility: visible;
  opacity: 1;
  transition:
    visibility 0s,
    opacity 0.2s linear;
`;

// TODO: TFR-44 move to icons group
export const CrossIcon = styled(FiX)`
  display: none;
`;

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div<{ $isOpen: boolean }>`
  background-color: ${({ theme }) => theme.colors.navyGreen};
  position: relative;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 1rem;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  ${({ $isOpen }) =>
    $isOpen &&
    css`
      width: 26.25rem;
      ${Input} {
        padding: 0.875rem 3.5rem 0.875rem 1rem;
        width: 100%;
      }
      ${CrossIcon} {
        display: block;
      }
      ${SearchIcon} {
        visibility: hidden;
        opacity: 0;
      }
    `}
`;
